import {FormControl, InputLabel, MenuItem, Select, Tooltip} from '@mui/material';
import {FC, MouseEvent} from 'react';
import {COMMON_STYLES} from '../../constants/styles';
import {PERIOD_OPTIONS} from '../../constants/period';
import {periodTooltipStyles as STYLES} from './PeriodFilterTooltip.styles';

interface Props {
  title: string;
  period: string;
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
  renderValue?: (value: string) => React.ReactNode;
}

export const PeriodFilterTooltip: FC<Props> = ({title, period, onClick, renderValue}) => {
  return (
    <Tooltip placement="top" title={title}>
      <FormControl sx={{minWidth: 130}} size="medium">
        <InputLabel id="period" sx={COMMON_STYLES.chartSelectLabel}>
          Период
        </InputLabel>
        <Select
          key="primary_period"
          labelId="period"
          id="period"
          label="Период"
          value={period}
          onClick={onClick}
          sx={STYLES.select}
          renderValue={renderValue}
        >
          {PERIOD_OPTIONS.map(({label, value}) => (
            <MenuItem key={`primary_${value}`} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Tooltip>
  );
};
